import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { curry } from 'fp-ts/lib/function';
import { logging, utils } from '@heimdall/core-common';
import { db } from '@heimdall/core-common-client';
import { Network } from '@heimdall/core-domain';
var executor = utils.TaskUtils.executeAndDecodeList(Network.Contact);
var logger = logging.instantiateLogger('heimdall:app:network:accessors');
export function getContactsDataFunction(_x, _x2) {
  return _getContactsDataFunction.apply(this, arguments);
}

function _getContactsDataFunction() {
  _getContactsDataFunction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(firestore, oid) {
    var log, getDoc, task;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log = logger.extend('getContactsDataFunction');
            getDoc = db.Firestore.getDocumentTasks(firestore);
            task = getDoc(['organization', oid, 'network']);
            log('Task Created');
            _context.next = 6;
            return executor(task);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getContactsDataFunction.apply(this, arguments);
}

export var getContactsData = curry(getContactsDataFunction);